import { underscore } from '@ember/string';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  keyForRelationship(key) {
    const underscored = underscore(key);
    return `${underscored}_id`;
  },
  normalize(type, payload) {
    const newPayload = {
      ...payload
    };
    newPayload.id = payload.uid;
    return this._super(type, newPayload);
  },
  serialize(snapshot) {
    const json = this._super(snapshot);
    json.uid = snapshot.id;
    return json;
  },
  serializeBelongsTo(snapshot, json, relationship) {
    const key = relationship.key;
    const belongsTo = snapshot.belongsTo(key);
    if (belongsTo) {
      const relationalId = belongsTo.record?.idOrTempId();
      json.address_id = relationalId;
    } else {
      this._super(snapshot, json, relationship);
    }
  }
});